import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";
import { mq } from "@styles/helpers";
import { Devices } from "@styles/tokens";

const ani = keyframes`
	0% {
    transform: rotate(0deg);
	}

	50% {
    transform: rotate(180deg);
	}

  100% {
    transform: rotate(360deg);
	}
`;

export const MenuWrap = styled.div`
    position: relative;
    width:100%;
    display:flex;
    gap:1rem;
    background:#fff;
    box-shadow: 0 0 3px rgba(0,0,0,0.25);
    border-radius: 5px;
    padding: 1rem;
    z-index: 100;
`;



export const MenuButton = styled.div<{active?:boolean}>`
    display:flex;
    align-items: center;
    height:32px;
    gap:0.7rem;
    border:1px solid ${props => props.active?"#2A848E":"#acacac"};
    padding: 0 1rem;
    border-radius: 5px;
    font-size: 16px;
    font-weight: 400;
    color:${props => props.active?"#fff":"#414141"};
    background:${props => props.active?"#2A848E":"#fff"};
    cursor: pointer;
    transition: all 0.1s ease-in-out;
    white-space: nowrap;
    
    svg{
        height:14px;
        path{
            transition: all 0.1s ease-in-out;
            fill:${props => props.active?"#fff":"#acacac"};
        }

        &:nth-of-type(2){
            height:8px;
        }
    }

    
    &:hover{
        border:1px solid #2A848E;
        background:#2A848E;
        color:#fff;
        svg{
            path{
                fill:#fff;
            }
        }
    }
`;

export const MenuRefresh = styled(MenuButton, { shouldForwardProp: (prop) => prop !== 'loading' })<{loading?:boolean}>`
    
    padding:0;

    > div{
        display:flex;
        justify-content: center;
        align-items: center;
        width:100%; 
        height: 100%;
        padding:0 1rem;
    }

    svg{
        animation: ${ani} 1.4s linear ${props => props.loading?"infinite":"1"};
        
    }
`;

export const MenuDropdown = styled.div`
    position: relative;
    height:100%;
`;

export const DropContent = styled.div<{show?:boolean}>`
    display: ${props => props.show?"block":"none"};
    position: absolute;
    top:38px;
    left:0px;
    width:max-content;
`;

export const DropList = styled.div`
    padding:0.5rem 0;
    background:#fff;
    box-shadow: 0 0 3px rgba(0,0,0,0.25);
    border-radius: 5px;
`;

export const DropItem = styled.div`
    padding:0.5rem 1.5rem;
    font-size: 14px;
    &:hover{
        background:#f5f5f5;
        cursor: pointer;
    }
`;


// animation:${ani} 1.4s linear ${props => true?"infinite":"none"};